<template>
  <div ref="scrollBody">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    scrollWatcher: Date
  },

  data() {
    return {
      needsToScroll: true
    }
  },

  methods: {
    maybeScrollToBottom() {
      if (this.needsToScroll) {
        this.scrollToBottom()
        this.needsToScroll = false
      }
    },

    scrollToBottom() {
      var scrollBody = this.$refs.scrollBody
      var scrollBodyHeight = scrollBody.scrollHeight

      scrollBody.scrollTop = scrollBodyHeight
    }
  },

  updated: function () {
    this.$nextTick(this.maybeScrollToBottom())
  },

  mounted: function () {
    this.$nextTick(this.maybeScrollToBottom())
  },

  watch: {
    async scrollWatcher() {
      await this.$nextTick()
      this.$nextTick(this.scrollToBottom())
    }
  }
}
</script>
